<div class="sort-section">
  
  <button 
    class="sort-trigger" 
    [matMenuTriggerFor]="sortMenu"
    [class.sort-trigger--active]="activeSortKey()" type="button"
  >
    <span class="sort-trigger__text">
      {{ 'orders.sort.sortBy' | translate }}: 
      <strong class="sort-value">
        {{ currentSelectedOption ? (currentSelectedOption.label | translate) : ('orders.sort.none' | translate) }}
      </strong>
    </span>

    @if (activeSortKey()) { 
      <span class="sort-trigger__clear" (click)="clearSort($event)" role="button" tabindex="0">
        <mat-icon>close</mat-icon>
      </span>
    } @else {
      <mat-icon class="sort-trigger__arrow">expand_more</mat-icon>
    }
  </button>

  <mat-menu #sortMenu="matMenu" xPosition="before" class="custom-sort-menu-panel">
    @for (option of options(); track option.key) { 
      <button 
        mat-menu-item 
        (click)="selectOption(option.key)"
        [class.is-active-option]="activeSortKey() === option.key" >
        <span class="option-text" matMenuItemText>{{ option.label | translate }}</span>
        
        @if (activeSortKey() === option.key) { 
          <mat-icon class="checkmark-icon">check</mat-icon>
        }
      </button>
    }
  </mat-menu>
</div>